import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IManagementUnitSearchModel, IManagementUnitSearchParamsModel } from '@apps-common/types/management/unit'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNITS = (model?: IManagementUnitSearchParamsModel, hideOrderUnits?: boolean) =>
  [
    'searchManagementUnits',
    model?.status,
    model?.mCentreId,
    model?.companyId,
    model?.techCompanyId,
    model?.networkType,
    model?.site,
    model?.accountNo,
    model?.imei,
    model?.serialNo,
    model?.mobileNo,
    model?.ipAddress,
    model?.simNo,
    model?.unprocessedCancellations,
    model?.hardwareToBeInvoiced,
    model?.pinnedUnits,
    model?.startDate,
    model?.endDate,
    model?.skip,
    model?.take,
    model?.orderBy,
    hideOrderUnits
  ].filter(Boolean)

export const searchUnits = async (model: IManagementUnitSearchParamsModel, hideOrderUnits = false): Promise<IManagementUnitSearchModel[]> =>
  axios.post(`/management/unit/Units?hideOrderUnits=${hideOrderUnits}`, { ...model }).then((res) => res.data?.data)

type QueryFnType = typeof searchUnits

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IManagementUnitSearchParamsModel
  hideOrderUnits?: boolean
}

export const useManagementSearchUnits = ({ config, model, hideOrderUnits }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS(model, hideOrderUnits),
    queryFn: () => searchUnits(model, hideOrderUnits)
  })
